import React, { useState, useRef } from 'react';
import { Popconfirm, Input, Space } from 'antd';
import Button from '@iso/components/uielements/button';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import notification from '@iso/components/Notification';
import HelperText from '@iso/components/utility/helper-text';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import PageTitleBar from '@iso/components/utility/PageTitleBar';
import PageTitleActions from '@iso/containers/Dashboard/PageTitleActions';
import FormWindow from '@iso/containers/Dashboard/FormWindow';
import EditTask from './EditTask';
import Scrollbars from '@iso/components/utility/customScrollBar';
import taskActions from '@iso/redux/task/actions';
import CardWrapper, { Box, StatusTag } from './Task.style';
import TableWrapper from '../../Tables/AntTables/AntTables.styles';
import { b64_to_utf8 } from '@iso/lib/helpers/utility';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import Loader from '@iso/components/utility/loader';

const { initData, deleteTask } = taskActions;

export default function Task() {
	const ses = sessionStorage.getItem("permissions");
	const arraySplit = b64_to_utf8(ses).split(",");
  const [selected, setSelected] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const { initialTasks, tasks } = useSelector((state) => state.Tasks);
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const searchInput = useRef(null);

  React.useEffect(() => {
    if (!initialTasks) {
      dispatch(initData());
    }
  }, [initialTasks]);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex, collum) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, collum)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, collum)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        title={"Pesquisar pelo "+dataIndex+" da Tarefa"}
        style={{
          color: '#000000',
        }}
      />
    ),
    onFilter: (value, record) =>
      record[collum].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === collum ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      width: '75%',
      render: (text) => <span>{text}</span>,
      ...getColumnSearchProps('Nome', 'name')
    },
    {
      title: 'Status',
      dataIndex: 'situation',
      key: 'situation',
      width: '25%',
      render: (text) => {
        let className;
        if (text === 'ativo' || text === 'Ativo' || text === 'ATIVO') {
          className = 'ativo';
        } else if ( text === 'inativo' || text === 'Inativo' || text === 'INATIVO' ) {
          className = 'inativo';
        }
        return <StatusTag className={className}>{text}</StatusTag>;
      },
    },
    {
      title: '',
      dataIndex: 'view',
      key: 'view',
      width: '10%',
      render: (_, task) =>{
        return (
          <div className="isoTaskBtnView">
            {arraySplit.includes('Tarefa_editar') || arraySplit.includes('all')  ? 
              <Link to={match.path+'/'+task._id}>
                <Button color="primary" className="taskViewBtn">
                  Editar
                </Button>
              </Link>
            : ''}
            {arraySplit.includes('Tarefa_excluir') || arraySplit.includes('all')  ? 
              <Popconfirm title="Deseja realmente deletar?" onConfirm={() => {
                const index = tasks.map(inv => inv._id).indexOf(task._id);
                dispatch(deleteTask(tasks[index]._id));
                notification('success', '1 Tarefa deletado');
              }}>
                <Button className="taskDltBtn" onClick={() => { }}>
                  <i className="ion-android-delete" />
                </Button>
              </Popconfirm>
            : ''}
          </div>
        )
      }
    },
  ];

  const rowSelection = {
    hideDefaultSelections: true,
    selectedRowKeys: selected,
    onChange: (selected) => setSelected(selected),
    selections: [
      {
        rowKey: 'all-data',
        text: 'Selecionar todos',
        onSelect: () => setSelected(tasks.map((task) => task._id)),
      },
      {
        rowKey: 'no-data',
        text: 'Desselecionar',
        onSelect: () => setSelected([]),
      },
    ],
    onSelection: (selected) => setSelected(selected),
  };

  return (
    <LayoutWrapper>
      
      <PageTitleBar title="Tarefas" />
      <PageTitleActions primary={{ key: 'create', label: "Adicionar", onClick: () => setEditingId('0') }} />
      <Box style={{ border: 'none', boxShadow: 'none' }}>
        {!initialTasks ? (
          <Loader />
        ) : (
          <CardWrapper>
            {tasks !== undefined && tasks.length === 0 ? (
              <HelperText text="Sem Tarefa" />
            ) : (
              <div className="isoTaskTable">
                <div
                  style={{ width: '100%' }}
                >
                  <TableWrapper
                    rowKey={"_id"}
                    rowSelection={rowSelection}
                    dataSource={tasks}
                    columns={columns}
                    pagination={{ defaultPageSize: 20, showSizeChanger: true, pageSizeOptions: ['10', '20', '50', '100'] }}
                    className="taskListTable"
                  />
                </div>
              </div>
            )}
          </CardWrapper>
        )}
      </Box>
          <FormWindow
        open={editingId !== null}
        title={editingId === '0' ? 'Cadastro de Tarefa' : 'Edição de Tarefa'}
        onClose={() => setEditingId(null)}
      >
        {({ footerEl }) =>
          editingId !== null ? (
            <EditTask
              taskId={editingId}
              inModal
              footerEl={footerEl}
              onCancel={() => setEditingId(null)}
              onSaved={() => {
                setEditingId(null);
                dispatch(initData());
              }}
            />
          ) : null
        }
      </FormWindow>
    </LayoutWrapper>
  );
}
 